var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.badageTips.tips)?_c('div',{class:("task-badage " + (_vm.badageTips.isDisabled ? 'disabled' : '') + "\n  " + (_vm.isLimitTask ? 'limit-task' : ''))},[_vm._v("\n  "+_vm._s(_vm.badageTips.tips)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }